import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const NavigationList = () => import(/* webpackChunkName: "navigation" */ '../components/SidebarNavigation/NavigationList');
const NavigationAccount = () => import(/* webpackChunkName: "account" */ '../components/SidebarNavigation/NavigationAccount');
const NavigationAccountData = () =>
    import(/* webpackChunkName: "account-data" */ '../components/SidebarNavigation/NavigationAccountData');
const Settings = () =>
    import(/* webpackChunkName: "settings" */ '../components/SidebarNavigation/Settings');
const NavigationAccountNotifications = () =>
    import(/* webpackChunkName: "account-notifications" */ '../components/SidebarNavigation/NavigationAccountNotifications');
const Support = () => import(/* webpackChunkName: "support" */ '../components/SidebarNavigation/Support');
const HomeView = () => import(/* webpackChunkName: "home" */ '../views/HomeView');
const OrganizationProfile = () => import(/* webpackChunkName: "organization-profile" */ '../components/SidebarNavigation/OrganizationProfile');
const ContactsList = () => import(/* webpackChunkName: "contacts-list" */ '../views/ContactsListView');
const QuestsView = () => import(/* webpackChunkName: "quests" */ '../views/QuestsView');
const QuestsGroupView = () => import(/* webpackChunkName: "quests-group" */ '../views/QuestsGroupView');
const NotificationsList = () => import(/* webpackChunkName: "notifications" */ '../views/NotificationsListView');
const QuestDetails = () => import(/* webpackChunkName: "quest-details" */ '../views/QuestDetails');
const QuestWizardDialog = () => import(/* webpackChunkName: "quest-wizard" */ '../components/QuestWizard/QuestWizardDialog');
const OrganizationRegistration = () => import(/* webpackChunkName: "organization-registration" */ '../views/OrganizationRegistration');

const config = [
    {
        path: '/contacts',
        name: 'contacts',
        component: ContactsList,
    },
    {
        path: '/quests',
        name: 'quests',
        component: QuestsView,
    },
    {
        path: '/quests/group/:id',
        name: 'quest-group',
        component: QuestsGroupView,
    },
    {
        path: '/quest/details/:id',
        name: 'quest-details',
        component: QuestDetails,
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: NotificationsList,
    },
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/organization-registration',
        name: 'organization-registration',
        component: OrganizationRegistration,
    },
];

const createRoutes = config => {
    const routes = [];
    config.forEach(entry => {
        routes.push({
            path: entry.path,
            name: entry.name,
            components: {
                default: entry.component,
                navigation: NavigationList,
            },
            meta: {
                persistDrawer: false,
            },
        });
        const pathPrefix = entry.path !== '/' ? entry.path : '';
        routes.push({
            path: `${pathPrefix}/wizard/:step?`,
            name: `${entry.name}-wizard`,
            components: {
                default: entry.component,
                questWizard: QuestWizardDialog,
            },
            meta: {
                questWizard: true,
                parentRouteName: entry.name,
            },
        });
        routes.push({
            path: `${pathPrefix}/account`,
            name: `${entry.name}-account`,
            components: {
                default: entry.component,
                navigation: NavigationAccount,
            },
            meta: {
                name: 'My Account',
                backRouteName: entry.name,
                parentRouteName: entry.name,
                persistDrawer: true,
            },
        });
        routes.push({
            path: `${pathPrefix}/account/data`,
            name: `${entry.name}-account-data`,
            components: {
                default: entry.component,
                navigation: NavigationAccountData,
            },
            meta: {
                name: 'My data',
                backRouteName: `${entry.name}-account`,
                parentRouteName: entry.name,
                persistDrawer: true,
            },
        });
        routes.push({
            path: `${pathPrefix}/account/notifications`,
            name: `${entry.name}-account-notifications`,
            components: {
                default: entry.component,
                navigation: NavigationAccountNotifications,
            },
            meta: {
                name: 'Notifications',
                backRouteName: `${entry.name}-account`,
                parentRouteName: entry.name,
                persistDrawer: true,
            },
        });
        routes.push({
            path: `${pathPrefix}/account/settings`,
            name: `${entry.name}-account-settings`,
            components: {
                default: entry.component,
                navigation: Settings,
            },
            meta: {
                name: 'Settings',
                backRouteName: `${entry.name}-account`,
                parentRouteName: entry.name,
                persistDrawer: true,
            },
        });
        routes.push({
            path: `${pathPrefix}/organization-profile`,
            name: `${entry.name}-organization-profile`,
            components: {
                default: entry.component,
                navigation: OrganizationProfile,
            },
            meta: {
                name: 'Organization profile',
                backRouteName: entry.name,
                parentRouteName: entry.name,
                persistDrawer: true,
            },
        });
        routes.push({
            path: `${pathPrefix}/support`,
            name: `${entry.name}-support`,
            components: {
                default: entry.component,
                navigation: Support,
            },
            meta: {
                name: 'Support',
                backRouteName: entry.name,
                parentRouteName: entry.name,
                persistDrawer: true,
            },
        });
    });
    return routes;
};

const routes = createRoutes(config);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(...props) {
        const [, , savedPosition] = props;
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

Vue.$router = router;

export default router;
